import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Personnel.css';

const AccountSettings = () => {
  const navigate = useNavigate();

  return (
    <div className="personnel-container">
      <div className="back-button-container">
        <button onClick={() => navigate('/personnel')} className="back-button">
          ← العودة للأفراد
        </button>
      </div>

      <div className="personnel-header">
        <h1>🔧 ضبط الحسابات</h1>
        <p>تعديل صلاحيات وإعدادات الحسابات</p>
      </div>

      <div className="coming-soon">
        <div className="coming-soon-icon">🚧</div>
        <h2>قيد التطوير</h2>
        <p>سيتم إضافة هذه الميزة قريباً</p>
      </div>
    </div>
  );
};

export default AccountSettings;